module.exports = __webpack_public_path__ + "media/images/talent/case6-badge-9f1adafeb1b1c872cd6ae367b297ca47.png";